import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import { closeRegister, cashFlowRegisterCountSave } from 'actions/EntityActions';
import { logout, showError } from 'actions/CommonActions';
import { formInput, clearFormInput } from 'actions/FormActions';
// Basic Components
import DialogHeader from 'screens/components/basic/DialogHeader'
import DecimalInput from 'screens/components/basic/DecimalInput';
import POSCashDrawerCount from './POSCashDrawerCount';

class POSCashOut extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: true,
            dialogConfirm: false,
            dialogDrawerCountCash: false
        };
    }

    componentWillMount() {
        this.props.formInput(null, 'closeRegistersSaveSuccess');
        this.props.formInput(null, 'closeRegistersSaveError');
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            this.props.formInput(null, 'cashoutAmount');
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess === true) {

                //clear paystone payment gateway id
                if (newProps.paystoneInStoreEnabled) {
                    localStorage.removeItem('TECHPOS_PAYSTONE_GATEWAY_ID');
                }

                // print the receipt of cash out
                this.printBalance(newProps.cashFlow);
                this.setState({ dialog: false });
                this.clearSaved();
                this.props.logout();
            }
            else if (newProps.saveSuccess === false) {
                this.props.showError(`${this.props.t('pos.cashOut.closeRegisterError')}`);
            }
        }
    }

    componentWillUnmount() {
        this.clearSaved();
    }

    saveRegisterCount = () => {
        if ((this.registerCountCheck(this.props.form[`POSCashDrawerCount100Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount50Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount20Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount10Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount5Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount2Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount1Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount25CentsCount`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount10CentsCount`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount5CentsCount`])) && this.props.cashFlow && this.props.cashFlow.id > 0) {
            let model = {
                HundredCount: this.props.form[`POSCashDrawerCount100Count`],
                FiftyCount: this.props.form[`POSCashDrawerCount50Count`],
                TwentyCount: this.props.form[`POSCashDrawerCount20Count`],
                TenCount: this.props.form[`POSCashDrawerCount10Count`],
                FiveCount: this.props.form[`POSCashDrawerCount5Count`],
                TwoCount: this.props.form[`POSCashDrawerCount2Count`],
                OneCount: this.props.form[`POSCashDrawerCount1Count`],
                TwentyFiveCoinCount: this.props.form[`POSCashDrawerCount25CentsCount`],
                TenCoinCount: this.props.form[`POSCashDrawerCount10CentsCount`],
                FiveCoinCount: this.props.form[`POSCashDrawerCount5CentsCount`],
                Id: this.props.cashFlow.id,
                BranchId: this.props.branchId,
                Type: LOOKUP.cashFlowInfo.cashFlowCountType.CashOut
            }
            this.props.cashFlowRegisterCountSave(model);
        }
    }

    registerCountCheck = (item) => {
        return item && Number(item) > 0;
    }

    clearSaved = () => {
        this.props.clearFormInput(`POSCashDrawerCount100Count`);
        this.props.clearFormInput(`POSCashDrawerCount50Count`);
        this.props.clearFormInput(`POSCashDrawerCount20Count`);
        this.props.clearFormInput(`POSCashDrawerCount10Count`);
        this.props.clearFormInput(`POSCashDrawerCount5Count`);
        this.props.clearFormInput(`POSCashDrawerCount2Count`);
        this.props.clearFormInput(`POSCashDrawerCount1Count`);
        this.props.clearFormInput(`POSCashDrawerCount25CentsCount`);
        this.props.clearFormInput(`POSCashDrawerCount10CentsCount`);
        this.props.clearFormInput(`POSCashDrawerCount5CentsCount`);
        this.props.clearFormInput(`POSCashOutCashOutAmount`);
    }

    printBalance = (newCashFlow) => {
        let ws = window.posWebSocket;
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const store = this.props.store;
        const cashFlow = newCashFlow;
        const device = deviceData.deviceWorkStationName;
        const user = this.props.authenticatedUser;
        const cashToReceive = (cashFlow.expectedBalance) ? cashFlow.expectedBalance.toFixed(2) : '0.00';
        const cashSale = (cashFlow.cashSale) ? cashFlow.cashSale.toFixed(2) : '0.00';
        const debitSale = (cashFlow.debitTotal) ? cashFlow.debitTotal.toFixed(2) : '0.00';
        const creditSale = (cashFlow.creditTotal) ? cashFlow.creditTotal.toFixed(2) : '0.00';
        const giftcardSale = (cashFlow.giftCardTotal) ? cashFlow.giftCardTotal.toFixed(2) : '0.00';
        const totalSale = (cashFlow.balance) ? cashFlow.balance.toFixed(2) : '0.00';
        const tips = (cashFlow.tipsTotal) ? cashFlow.tipsTotal.toFixed(2) : '0.00';
        const cashIn = (cashFlow.cashInAmount) ? cashFlow.cashInAmount.toFixed(2) : '0.00';
        const cashRefund = (cashFlow.cashRefund) ? cashFlow.cashRefund.toFixed(2) : '0.00';
        const creditReturn = (cashFlow.creditReturn) ? cashFlow.creditReturn.toFixed(2) : '0.00';
        const debitReturn = (cashFlow.debitReturn) ? cashFlow.debitReturn.toFixed(2) : '0.00';
        const storeCreditReturn = (cashFlow.storeCreditReturn) ? cashFlow.storeCreditReturn.toFixed(2) : '0.00';
        const giftCardReturn = (cashFlow.giftCardReturn) ? cashFlow.giftCardReturn.toFixed(2) : '0.00';
        const cashTransactionCount = (cashFlow.cashTransactionCount) ? cashFlow.cashTransactionCount : 0;
        const debitTransactionCount = (cashFlow.debitTransactionCount) ? cashFlow.debitTransactionCount : 0;
        const creditTransactionCount = (cashFlow.creditTransactionCount) ? cashFlow.creditTransactionCount : 0;
        const giftTransactionCount = (cashFlow.giftTransactionCount) ? cashFlow.giftTransactionCount : 0;
        const cashOutDate = cashFlow.cashOutDate;
        const cashDrops = cashFlow.cashDrops.map(c => {
            return {
                Amount: c.amount,
                TimeText: c.cashDropTimeText
            };
        });
        const hundredBill = this.props.form[`POSCashDrawerCount100Count`] ? Number(this.props.form[`POSCashDrawerCount100Count`]) : 0;
        const fiftyBill = this.props.form[`POSCashDrawerCount50Count`] ? Number(this.props.form[`POSCashDrawerCount50Count`]) : 0;
        const twentyBill = this.props.form[`POSCashDrawerCount20Count`] ? Number(this.props.form[`POSCashDrawerCount20Count`]) : 0;
        const tenBill = this.props.form[`POSCashDrawerCount10Count`] ? Number(this.props.form[`POSCashDrawerCount10Count`]) : 0;
        const fiveBill = this.props.form[`POSCashDrawerCount5Count`] ? Number(this.props.form[`POSCashDrawerCount5Count`]) : 0;
        const twoCoin = this.props.form[`POSCashDrawerCount2Count`] ? Number(this.props.form[`POSCashDrawerCount2Count`]) : 0;
        const oneCoin = this.props.form[`POSCashDrawerCount1Count`] ? Number(this.props.form[`POSCashDrawerCount1Count`]) : 0;
        const twentyFiveCoin = this.props.form[`POSCashDrawerCount25CentsCount`] ? Number(this.props.form[`POSCashDrawerCount25CentsCount`]) : 0;
        const tenCoin = this.props.form[`POSCashDrawerCount10CentsCount`] ? Number(this.props.form[`POSCashDrawerCount10CentsCount`]) : 0;
        const fiveCoin = this.props.form[`POSCashDrawerCount5CentsCount`] ? Number(this.props.form[`POSCashDrawerCount5CentsCount`]) : 0;

        if (ws && ws.readyState === WebSocket.OPEN && !this.props.PadVersion) {
            const model = {
                Command: 'PRINT CASHOUT',
                Data: JSON.stringify({
                    CompanyName: store.name,
                    EmployeeName: `${user.firstName} ${user.lastName}`,
                    Register: device,
                    CashToReceive: cashToReceive,
                    CashSale: cashSale,
                    DebitSale: debitSale,
                    CreditSale: creditSale,
                    TotalSale: totalSale,
                    GiftSale: giftcardSale,
                    Tips: tips,
                    CashIn: cashIn,
                    CashRefund: cashRefund,
                    CreditReturn: creditReturn,
                    DebitReturn: debitReturn,
                    GiftCardReturn: giftCardReturn,
                    StoreCreditReturn: storeCreditReturn,
                    CashTransactionCount: cashTransactionCount,
                    DebitTransactionCount: debitTransactionCount,
                    CreditTransactionCount: creditTransactionCount,
                    GiftTransactionCount: giftTransactionCount,
                    CashoutDate: cashOutDate,
                    CashDrops: cashDrops,
                    HundredBill: hundredBill,
                    FiftyBill: fiftyBill,
                    TwentyBill: twentyBill,
                    TenBill: tenBill,
                    FiveBill: fiveBill,
                    TwoCoin: twoCoin,
                    OneCoin: oneCoin,
                    TwentyFiveCoin: twentyFiveCoin,
                    TenCoin: tenCoin,
                    FiveCoin: fiveCoin
                })
            };
            ws.send(JSON.stringify(model));
        }
        else if (this.props.PadVersion) {
            const model = {
                Command: 'PRINT CASHOUT',
                Data: {
                    CompanyName: store.name,
                    EmployeeName: `${user.firstName} ${user.lastName}`,
                    Register: device,
                    CashToReceive: cashToReceive,
                    CashSale: cashSale,
                    DebitSale: debitSale,
                    CreditSale: creditSale,
                    TotalSale: totalSale,
                    GiftSale: giftcardSale,
                    Tips: tips,
                    CashIn: cashIn,
                    CashRefund: cashRefund,
                    CreditReturn: creditReturn,
                    DebitReturn: debitReturn,
                    GiftCardReturn: giftCardReturn,
                    StoreCreditReturn: storeCreditReturn,
                    CashTransactionCount: cashTransactionCount,
                    DebitTransactionCount: debitTransactionCount,
                    CreditTransactionCount: creditTransactionCount,
                    GiftTransactionCount: giftTransactionCount,
                    CashDrops: cashDrops,
                    HundredBill: hundredBill,
                    FiftyBill: fiftyBill,
                    TwentyBill: twentyBill,
                    TenBill: tenBill,
                    FiveBill: fiveBill,
                    TwoCoin: twoCoin,
                    OneCoin: oneCoin,
                    TwentyFiveCoin: twentyFiveCoin,
                    TenCoin: tenCoin,
                    FiveCoin: fiveCoin
                }
            };
            cashoutPrinting(JSON.stringify(model));
        }
    }

    cashOut = () => {
        // send data to api
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        this.props.closeRegister(deviceData.id, this.props.branchId, false, this.props.cashoutAmount);
        // close dialog confirm
        this.closeConfirmCashOut();
    }

    openConfirmCashOut = () => {
        this.setState({ dialogConfirm: true });
    }

    closeConfirmCashOut = () => {
        //OK to run here as the endpoint will update db entry if same cashflowId is passed to endpoint for an existing db entry
        this.saveRegisterCount();
        this.setState({ dialogConfirm: false });
    }

    openDrawerCountCash = () => {
        this.props.openDrawer();
        this.setState({ dialogDrawerCountCash: true });
    }

    closeDrawerCountCash = () => {
        this.setState({ dialogDrawerCountCash: false });
    }

    render() {
        const { t } = this.props; 
        const p = this.props;

        return (
            <div>
                <POSCashDrawerCount show={this.state.dialogDrawerCountCash} onCancel={() => this.closeDrawerCountCash()} onConfirm={() => this.closeDrawerCountCash()} source={"cashOut"} />
                <DialogInput
                    title={<DialogHeader text={t("pos.cashOut.cashOut")} classicClass="posDialogClassic" />}
                    modal={true}
                    open={p.show && this.state.dialog}
                    style={{ zIndex: '950' }}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => p.onCancel()} />,
                        <Button
                            key={3}
                            name="buttonConfirmCashIn"
                            label={t('pos.cashOut.openDrawerAndCountCash')}
                            primary={true}
                            className="btn-space-20"
                            onTouchTap={() => this.openDrawerCountCash()} />,
                        <Button
                            key={2}
                            name="buttonConfirmCashOut"
                            label={t('common.confirm')}
                            className="pull-right btnNewBrandPOS"
                            primary={true}
                            onTouchTap={() => this.openConfirmCashOut()} />]}
                    contentStyle={{ width: '65%' }}>
                    <div>
                        <div className="row modal-font-family">
                            <div className="col-lg-12">
                                {/* <h2 className="text-center">Are you sure you want to Cash Out?</h2> */}
                                <p className="alert alert-warning">
                                    {t('pos.cashOut.cashOutWarning')}
                                    <br /><b>{t('pos.cashOut.bringReceiptReminder')}</b>
                                </p>
                            </div>
                            {
                                this.props.cashoutAmount > 0 &&
                                <div className="col-lg-12">
                                    <DecimalInput
                                        name={`${p.name}CashOutAmount`}
                                        label={t('pos.cashOut.cashOutAmountSep')}
                                        floatingLabelText={t('pos.cashOut.cashOutAmountSep')}
                                        hintText={t('pos.cashOut.cashOutAmountSep')}
                                        fullWidth={true}
                                        required />
                                </div>
                            }
                        </div>
                    </div>
                </DialogInput>

                {/* Confirmation Dialog */}
                <DialogInput
                    title={<DialogHeader text={t('pos.cashOut.cashOutConfirmation')} classicClass="posDialogClassic" />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={t('common.cancel')}
                            onTouchTap={() => this.closeConfirmCashOut()} />,
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label={t('common.confirm')}
                            className="btnNewBrandPOS"
                            primary={true}
                            onTouchTap={() => this.cashOut()} />]}
                    modal={true}
                    open={this.state.dialogConfirm}>
                    <div className="modal-font-family">
                        {t('pos.cashOut.confirmCashOut')}
                    </div>
                </DialogInput>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        store: state.common.store,
        authenticatedUser: state.common.authenticatedUser,
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        cashFlow: state.entity.cashFlow,
        posOrder: state.entity.posOrder,
        branchId: state.common.branchId,
        saveSuccess: state.form["closeRegistersSaveSuccess"],
        saveError: state.form["closeRegistersSaveError"],
        cashoutAmount: state.form["POSCashOutCashOutAmount"] || 0,
        form: state.form,
        paystoneInStoreEnabled: state.common.applicationSettings.paystoneInStoreEnabled
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        closeRegister: (deviceId, branchId, fromCashIn, cashoutAmount) => dispatch(closeRegister(deviceId, branchId, fromCashIn, cashoutAmount)),
        cashFlowRegisterCountSave: (model) => dispatch(cashFlowRegisterCountSave(model)),
        logout: () => dispatch(logout()),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSCashOut))